/**
 * Translate shop product titles and descriptions using translations from API.
 * Falls back to the original value (Chinese) if no translation exists for the current locale.
 */
export function useShopI18n() {
  const { locale } = useI18n()

  function translateTitle(titleTranslations: Record<string, string> | null | undefined, fallback: string): string {
    if (!titleTranslations) return fallback
    return titleTranslations[locale.value] ?? fallback
  }

  function translateDescription(descTranslations: Record<string, string> | null | undefined, fallback: string): string {
    if (!descTranslations) return fallback
    return descTranslations[locale.value] ?? fallback
  }

  return { translateTitle, translateDescription }
}
